import { render, staticRenderFns } from "./settingsContainer.vue?vue&type=template&id=18ba250c"
import script from "./settingsContainer.vue?vue&type=script&lang=js"
export * from "./settingsContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports